<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <SharedWindow title="Ввод" :is-center="true" @close="handleClose">
    <div :class="b('intro')">
      <p :class="b('subtitle')">
        {{
          $t(
            "Переведите средства на этот адрес — баланс обновится после зачисления"
          )
        }}
      </p>

      <div :class="b('tabs')" role="tablist">
        <button
          type="button"
          :class="b('tab')"
          role="tab"
          :aria-selected="false"
          @click="openFiatDeposit"
        >
          Fiat
        </button>
        <button
          type="button"
          :class="b('tab', { active: true })"
          role="tab"
          :aria-selected="true"
        >
          Crypto
        </button>
      </div>
    </div>

    <div :class="b('wrapper')">
      <div :class="b('fields')">
        <div :class="b('field')">
          <p :class="b('field-label')">
            {{ $t("Монета") }}
          </p>

          <SharedSelect
            view="light"
            :options="displayedCurrencyOptions"
            v-model:value="coinId"
            :isCryptoIcon="true"
            :icon="displayedCurrencyIcon"
            @update:value="loadChains"
          />
        </div>

        <div :class="b('field')" v-if="chains.length">
          <p :class="b('field-label')">
            {{ $t("Выберите сеть") }}
          </p>

          <SharedSelect
            view="light"
            :options="displayedChainOptions"
            v-model:value="chain"
            @update:value="getDepositAddress"
          />
        </div>

        <div :class="b('field')" v-if="address?.addressDeposit">
          <p :class="b('field-label')">
            {{ $t("Адрес кошелька") }}
            <button
              type="button"
              :class="b('copy-btn')"
              @click="copyAddressToCliboard"
            >
              {{ $t("копировать") }}
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <rect x="8" y="8" width="10" height="10" rx="2" />
                <path
                  d="M6 15H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v1"
                />
              </svg>
            </button>
          </p>

          <p>{{ address.addressDeposit }}</p>
        </div>
        <div :class="b('field')" v-if="address?.tagDeposit">
          <p :class="b('field-label')">
            {{ $t("Адрес тэг кошелька") }}
            <button
              type="button"
              :class="b('copy-btn')"
              @click="copyTagToCliboard"
            >
              {{ $t("копировать") }}
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <rect x="8" y="8" width="10" height="10" rx="2" />
                <path
                  d="M6 15H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v1"
                />
              </svg>
            </button>
          </p>

          <p>{{ address.tagDeposit }}</p>
        </div>
      </div>
    </div>
  </SharedWindow>
</template>
